/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { Box, Button, Modal, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import axios from '../../services/axios';
import RelatorioPDF from './RelatorioPDF';
import { Title } from '../../styles/GlobalStyles';

function RelatorioModal({ id, open, onClose }) {
  const [relatorioData, setRelatorioData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showReport, setShowReport] = useState(false); // Controla exibição do relatório

  const handleGenerateReport = async () => {
    setLoading(true);

    try {
      const response = await axios.get(`/viagens/impressao/${id}`);
      if (response.data) {
        setRelatorioData(response.data);
        setShowReport(true); // Exibe o relatório
        toast.success('Relatório gerado com sucesso!');
      } else {
        toast.warn('Nenhum dado encontrado para a viagem informada.');
        setShowReport(false);
      }
    } catch (error) {
      toast.error(
        error.response?.data?.error || 'Erro ao gerar o relatório no servidor.'
      );
      setShowReport(false);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShowReport(false); // Oculta o relatório
    setRelatorioData(null); // Reseta os dados do relatório
    onClose(); // Fecha o modal
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant="h6" component="h2">
          <Title>Gerar Relatório de Viagem</Title>
        </Typography>

        {/* Botões */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 2,
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            onClick={handleGenerateReport}
            disabled={loading}
          >
            {loading ? 'Carregando...' : 'Gerar Relatório'}
          </Button>

          <Button
            variant="contained"
            color="secondary"
            disabled={loading}
            onClick={handleClose}
          >
            Fechar
          </Button>
        </Box>

        {/* Exibição do relatório */}
        {showReport && relatorioData && (
          <Box>
            {/* Visualizador PDF */}
            <PDFViewer style={{ width: '100%', height: '500px' }}>
              <RelatorioPDF data={relatorioData} />
            </PDFViewer>

            {/* Botão para Download */}
            <PDFDownloadLink
              document={<RelatorioPDF data={relatorioData} />}
              fileName={`Relatorio_Viagem_${id}.pdf`}
              style={{ textDecoration: 'none' }}
            >
              <Button variant="contained" color="secondary" sx={{ mt: 2 }}>
                Baixar PDF
              </Button>
            </PDFDownloadLink>
          </Box>
        )}
      </Box>
    </Modal>
  );
}

export default RelatorioModal;
